import { useLayoutEffect } from 'react'

export default function StartupReady() {
  useLayoutEffect(() => {
    document.documentElement.classList.remove('app-loading')
  }, [])

  return null
}
